import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface CaseSearchSectionProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function CaseSearchSection({ searchTerm, onSearchChange }: CaseSearchSectionProps) {
  return (
    <div className="flex items-center gap-4">
      <Input
        placeholder="Søk i saker..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="max-w-sm"
      />
      {searchTerm && (
        <Button 
          variant="ghost" 
          onClick={() => onSearchChange("")}
          size="sm"
        >
          Nullstill
        </Button>
      )}
    </div>
  );
}